import React, { lazy } from 'react';
import Loadable from 'components/Loadable';
import ResiLayout from 'layout/ResiLayout';
import ResiGuard from 'utils/route-guard/ResiGuard';
import VerifyIdentityRegistrationGuard from 'utils/route-guard/VerifyIdentityRegistrationGuard';

const ManageRentals = Loadable(lazy(() => import('pages/resi/rentals/Rentals')));
const MaintenanceError = Loadable(lazy(() => import('pages/maintenance/404')));
const ManageGuests = Loadable(lazy(() => import('pages/resi/guests/Guests')));
// const ManageGuests2 = Loadable(lazy(() => import('pages/occupant/ManageGuests')));
// const InviteGuest = Loadable(lazy(() => import('pages/occupant/InviteGuest')));
const UsersAccessLogs = Loadable(lazy(() => import('pages/occupant/UsersAccessLogs')));
// const EditGuestInvite = Loadable(lazy(() => import('pages/occupant/EditGuestInvite')));
// const EditGuestAccess = Loadable(lazy(() => import('pages/occupant/EditGuestAccess')));
// const EditVisitor = Loadable(lazy(() => import('pages/occupant/EditVisitor')));
// const AddOtc = Loadable(lazy(() => import('pages/occupant/AddOtc')));
// const RevokeOtc = Loadable(lazy(() => import('pages/occupant/RevokeOtc')));
const ManageOccupants = Loadable(lazy(() => import('pages/resi/occupants/Occupants')));
const ManageAccessKeys = Loadable(
    lazy(() => import('pages/resi/access-keys/AccessKeys'))
);
// const ManageOccupants2 = Loadable(lazy(() => import('pages/occupant/ManageOccupants')));
// const InviteOccupant = Loadable(lazy(() => import('pages/occupant/InviteOccupant')));
// const EditOccupant = Loadable(lazy(() => import('pages/occupant/EditOccupant')));
// const EditOccupantInvite = Loadable(
//     lazy(() => import('pages/occupant/EditOccupantInvite'))
// );
const UploadIdentification = Loadable(
    lazy(() => import('pages/occupant/UploadIdentification'))
);
const ManageVehicles = Loadable(lazy(() => import('pages/occupant/ManageVehicles')));
// const ManageVehicles = Loadable(lazy(() => import('pages/resi/vehicles/Vehicles')));

// const AddVehicle = Loadable(lazy(() => import('pages/occupant/AddVehicle')));
// const EditVehicle = Loadable(lazy(() => import('pages/occupant/EditVehicle')));
// const ManageVehiclesV2 = Loadable(lazy(() => import('pages/occupant/ManageVehiclesV2')));
// const AddVehicleV2 = Loadable(lazy(() => import('pages/occupant/AddVehicleV2')));
// const VehicleDetailsV2 = Loadable(lazy(() => import('pages/occupant/VehicleDetailsV2')));
// const AccessDenied = Loadable(lazy(() => import('pages/resi/AccessDenied')));
const SupportPage = Loadable(lazy(() => import('pages/resi/support/Support')));
// ==============================|| RESI ROUTING ||============================== //

const ResiRoutes = {
    path: '/',
    children: [
        // {
        //     path: 'access-denied',
        //     element: <AccessDenied />
        // },
        {
            path: 'verify-identity',
            element: (
                <VerifyIdentityRegistrationGuard>
                    <UploadIdentification fromRegistration={true} />
                </VerifyIdentityRegistrationGuard>
            )
        },

        {
            path: 'consumer',
            element: (
                <ResiGuard>
                    <ResiLayout />
                </ResiGuard>
            ),
            children: [
                {
                    index: true,
                    element: null
                },
                // TODO: maybe add this back in when we have DASHBOARD so `/` will always go to dashbaord
                // {
                //     path: '/',
                //     element: <ManageGuests />
                // },
                {
                    path: 'upload-identification',
                    element: <UploadIdentification />
                },
                {
                    path: 'guests',
                    element: <ManageGuests />
                },
                {
                    path: 'access-logs',
                    element: <UsersAccessLogs />
                },

                // {
                //     path: 'guests/invite',
                //     element: <InviteGuest />
                // },
                // {
                //     path: 'guests/invite/:id',
                //     element: <EditGuestInvite />
                // },
                // {
                //     path: 'guests/access-key/:id',
                //     element: <EditGuestAccess />
                // },
                // {
                //     path: 'guests/visitors/:id',
                //     element: <EditVisitor />
                // },
                // {
                //     path: 'guests/otc/add',
                //     element: <AddOtc />
                // },
                // {
                //     path: 'guests/otc/revoke/:id',
                //     element: <RevokeOtc />
                // },
                {
                    path: 'occupants',
                    element: <ManageOccupants />
                },
                {
                    path: 'access-keys',
                    element: <ManageAccessKeys />
                },
                // {
                //     path: 'occupants/:id',
                //     element: <EditOccupant />
                // },
                // {
                //     path: 'occupants/invite',
                //     element: <InviteOccupant />
                // },
                // {
                //     path: 'occupants/register/:registrationId',
                //     element: <EditOccupantInvite />
                // },
                // {
                //     path: 'occupants/invite/:inviteId',
                //     element: <EditOccupantInvite />
                // },
                {
                    path: 'vehicles',
                    element: <ManageVehicles />
                },
                // {
                //     path: 'vehicles/add',
                //     element: <AddVehicle />
                // },
                // {
                //     path: 'vehicles/:tag',
                //     element: <EditVehicle />
                // },
                // {
                //     path: 'vehicles2',
                //     element: <ManageVehiclesV2 />
                // },
                // {
                //     path: 'vehicles2/add',
                //     element: <AddVehicleV2 />
                // },
                // {
                //     path: 'vehicles2/:vehicleId',
                //     element: <VehicleDetailsV2 />
                // },
                {
                    path: 'resi-rentals',
                    element: <ManageRentals />
                },
                {
                    path: 'support',
                    element: <SupportPage />
                },
                {
                    path: '*',
                    element: <MaintenanceError />
                }
            ]
        }
    ]
};

export default ResiRoutes;
